import { Home, Loader2 } from 'lucide-react';
import { useState } from 'react';
import type { TenantSelection } from '@yawi/types';

interface TenantPickerProps {
  tenants: TenantSelection[];
  loading?: boolean;
  /** Recibe el objeto completo (no solo el id) porque cada opción puede pertenecer a un MasterUser distinto. */
  onConfirm: (tenant: TenantSelection) => void;
  title?: string;
  description?: string;
}

export const TenantPicker: React.FC<TenantPickerProps> = ({
  tenants,
  loading = false,
  onConfirm,
  title = 'Selecciona tu comunidad',
  description = 'Tienes acceso a varias comunidades. Elige una para continuar.',
}) => {
  const [selectedTenantId, setSelectedTenantId] = useState<string>('');

  const selectedTenant = tenants.find((t) => t.tenantId === selectedTenantId);

  return (
    <div className="py-4">
      <h2 className="text-xl font-bold text-slate-800 mb-2">{title}</h2>
      <p className="text-slate-500 mb-6">{description}</p>

      <div className="space-y-3 mb-6">
        {tenants.map((tenant) => (
          <button
            key={tenant.tenantId}
            onClick={() => setSelectedTenantId(tenant.tenantId)}
            className={`w-full p-4 rounded-xl border-2 text-left transition-all ${
              selectedTenantId === tenant.tenantId
                ? 'border-purple-500 bg-purple-50'
                : 'border-slate-200 bg-white hover:border-slate-300'
            }`}
          >
            <div className="flex items-center gap-3">
              {tenant.logoUrl ? (
                <img src={tenant.logoUrl} alt="" className="w-10 h-10 rounded-lg object-cover" />
              ) : (
                <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center">
                  <Home size={20} className="text-slate-400" />
                </div>
              )}
              <div>
                <p className="font-semibold text-slate-800">{tenant.tenantName}</p>
                <p className="text-xs text-slate-500 capitalize">{tenant.role.toLowerCase()}</p>
              </div>
            </div>
          </button>
        ))}
      </div>

      <button
        onClick={() => selectedTenant && onConfirm(selectedTenant)}
        disabled={!selectedTenant || loading}
        className="w-full py-3 rounded-xl font-semibold text-sm text-white flex items-center justify-center gap-2 transition-all disabled:opacity-50"
        style={{
          background: 'linear-gradient(135deg, #8B5CF6, #6366F1)',
          boxShadow: '0 4px 16px rgba(139, 92, 246, 0.35)',
        }}
      >
        {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Continuar'}
      </button>
    </div>
  );
};
